import { render, staticRenderFns } from "./AssessmentType.vue?vue&type=template&id=87202a4e"
import script from "./AssessmentType.vue?vue&type=script&lang=js"
export * from "./AssessmentType.vue?vue&type=script&lang=js"
import style0 from "./AssessmentType.vue?vue&type=style&index=0&id=87202a4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports